:host {
  display: block;
  max-width: 100%;
}

.title {
  color: var(--main-titles-inputs-600);
}

.ds-icons {
  font-family: 'ds-bitdefender' !important;
}

.title-text-container {
  min-width: 0;
}

.flag-svg {
  width: 21px;
  height: 15px;
}

.header-content {
  width: calc(100% - 24px);
}

.name-container {
  max-height: 32px;
  gz-text {
    color: var(--main-titles-inputs-600);
  }
}

.confidence {
  color: var(--chart-300-icon-buttons);
}

details {
  border-bottom: 1px solid var(--chart-101-pressed-dividers);
}

details > summary {
  list-style: none;
  display: flex;
  padding: var(--spacer) 0;
}

details > summary::marker, /* Latest Chrome, Edge, Firefox */
details > summary::-webkit-details-marker /* Safari */
{
  display: none;
}

details > summary:hover {
  background: var(--chart-051-hover);
}

details > summary::after,
details[open] > summary::after {
  font-size: var(--header-font-size-large);
  color: var(--chart-302-icon-buttons-titles);
  align-self: center;
}

details > summary::after {
  //.ds-icon-arrow_down_expand
  @extend .ds-icons;
  content: '\e901';
  color: var(--chart-302-icon-buttons-titles);
}

details[open] > summary::after {
  //.ds-icon-arrow_up_collapse
  @extend .ds-icons;
  content: '\e904';
}

.w-3 {
  width: calc(3 * var(--spacer));
}
